export function slider() {

    let $owl = $('.slider .owl-carousel').owlCarousel({
        loop:true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        autoplaySpeed: 1000,
		nav: true,
		navText: [
			// next
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.41 60.24"><polyline points="30.05 0.35 0.7 30.93 29.19 59.89" style="fill:none;stroke:#8fa9c6;stroke-miterlimit:10"/></svg>',
			// prev
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.41 60.24"><polyline points="0.36 0.35 29.71 30.93 1.21 59.89" style="fill:none;stroke:#8fa9c6;stroke-miterlimit:10"/></svg>',
		],
        dots: false,

        responsive: {
            768: {
                nav: true,
            }
       }
    });

    $('.owl-dots').on('click', '.owl-dots__button', function(e) {
        owl.trigger('to.owl.carousel', [$(this).index(), 300]);
    });

}